<template lang="pug">
svg.icon(v-if="svg.id", :class="[`icon-${name}`, { inline }]")
  use(:xlink:href="`#${svg.id}`")
</template>

<script>
import "../style/icon.scss";

export default {
  name: "Icon",
  props: {
    name: {
      type: String,
      required: true,
    },
    group: {
      type: String,
      default: "",
    },
    inline: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    svg: {},
  }),
  watch: {
    name: {
      handler() {
        try {
          const group = this.group ? `/${this.group}` : "";
          const icon = require(`../../../static/icons${group}/${this.name}.svg`);
          this.svg = icon.default;
        } catch (e) {
          this.svg = {};
          this.$emit("error");
        }
      },
      immediate: true,
    },
  },
};
</script>
